import "./OnRsvpModal.css";
import { Button, Modal } from "@mui/material";
import { Box } from "@mui/system";
import { StartingPoint } from "../../interfaces/StartingPoint.interface";
import { formatTime } from "../../utilities/helpers/formatTime";
import { RsvpDetails } from "../../interfaces/RsvpDetails.interface";

interface OnRsvpModalProps {
  isModalOpen: boolean;
  rsvpResponse: RsvpDetails | null;
  startingPoint: StartingPoint | null;
  onClose: () => void;
}

const attendingTitle = "Yay, you are coming!";
const notAttendingTitle = "Boo, we'll miss you!";

export const OnRsvpModal = ({
  isModalOpen,
  rsvpResponse,
  startingPoint,
  onClose,
}: OnRsvpModalProps) => {
  if (!rsvpResponse) {
    return null;
  }

  const { edit_token: editToken, is_attending: isAttending } = rsvpResponse;
  const editPath = `http://www.runcindyrun.com/?edit-token=${editToken}`;

  return (
    <Modal
      open={isModalOpen}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="modalContent">
        <div>
          <h2>{isAttending ? attendingTitle : notAttendingTitle}</h2>
          <p>
            IMPORTANT: Save the following URL and don't share it with anyone.
            Anyone can edit your response here:{" "}
            <a href={editPath}>{editPath}</a>
          </p>

          {startingPoint && (
            <p>
              We will see you at {startingPoint.name} at{" "}
              {formatTime(startingPoint.time)}!
            </p>
          )}

          {startingPoint && <p>{startingPoint.address}</p>}
        </div>
        <Button variant="contained" onClick={onClose}>
          Done
        </Button>
      </Box>
    </Modal>
  );
};
